export const INGREDIENT_SHOP = [
  // เนื้อสัตว์
  { id: 'raw_pork', name: 'หมูชิ้น 🥩', price: 20 },
  { id: 'raw_chicken', name: 'ไก่สด 🍗', price: 20 },
  { id: 'raw_shrimp', name: 'กุ้งสด 🦐', price: 30 },
  { id: 'raw_egg', name: 'ไข่ไก่ 🥚', price: 10 },
  // ผักและสมุนไพร
  { id: 'raw_papaya', name: 'มะละกอ 🥒', price: 15 },
  { id: 'raw_chili', name: 'พริกสด 🌶️', price: 10 },
  { id: 'raw_garlic', name: 'กระเทียม 🧄', price: 10 },
  { id: 'raw_curry_herbs', name: 'สมุนไพรแกง 🌿', price: 15 },
  { id: 'raw_tomato', name: 'มะเขือเทศ 🍅', price: 10 },
  { id: 'raw_sato', name: 'สะตอ 🫘', price: 25 },
  // คาร์โบไฮเดรต
  { id: 'raw_noodles', name: 'เส้นต่างๆ 🍜', price: 15 }
];

export const BUFF_SHOP = [
  { id: 'tool_cleaver', name: 'มีดปังตอคู่ 🔪', desc: 'การ [สับ/หั่น] ไม่เสีย AP', price: 150 },
  { id: 'tool_mortar', name: 'ครกหินอ่างศิลา 🥣', desc: 'เมนู [โขลก] ได้เงิน x1.5', price: 200 },
  { id: 'tool_brass_pan', name: 'กระทะทองเหลือง 🍲', desc: 'เมนู [ต้ม/เคี่ยว] ได้เงิน +20 บาท', price: 180 },
  { id: 'tool_iron_wok', name: 'กระทะเหล็ก 🍳', desc: 'เมนู [ผัด/คั่ว] ได้เงิน x1.5', price: 200 },
  { id: 'tool_charcoal_grill', name: 'เตาถ่าน ♨️', desc: 'เมนู [ย่าง] ได้เงิน +25 บาท', price: 180 },
  { id: 'tool_mixing_bowl', name: 'กะละมังผสม 🥗', desc: 'การ [คลุกเคล้า] ไม่เสีย AP', price: 150 },
  { id: 'tool_deep_fryer', name: 'หม้อทอด 🥘', desc: 'เมนู [ทอด] ได้เงิน x2', price: 250 }
];